// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { PrivateAxios } from "../../apiEcommerce";

// export const addCart = createAsyncThunk(
//   "cart/addCart",
//   async ({ eco_products_id, count, color_id }, { rejectWithValue }) => {
//     try {
//       const response = await PrivateAxios.post(
//         `/api/ecomerce/cart/updateOrCreate`,
//         { eco_products_id, count, color_id },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid status.");
//       }

//       return response.data.data;
//     } catch (error) {
//       console.error("Error add to cart:", error.message);
//       return rejectWithValue(
//         error.response?.data || error.request || "Failed to add to cart"
//       );
//     }
//   }
// );

// export const fetchAllOrdersCart = createAsyncThunk(
//   "ordersCart/fetchAllOrdersCart",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await PrivateAxios.get(`/api/ecomerce/cart/getall`, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid code.");
//       }

//       return response.data.data.orders;
//     } catch (error) {
//       console.error("Error fetching order:", error.message);
//       return rejectWithValue(
//         error.response?.data || error.request || "Failed to fetch order"
//       );
//     }
//   }
// );

// export const removeCart = createAsyncThunk(
//   "cart/removeCart",
//   async ({ cart_id }, { rejectWithValue }) => {
//     try {
//       const response = await PrivateAxios.post(
//         `/api/ecomerce/cart/remove`,
//         { cart_id },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.data.status) {
//         return rejectWithValue(response.data.message || "Invalid status.");
//       }

//       return response.data.data;
//     } catch (error) {
//       console.error("Error remove to cart:", error.message);
//       return rejectWithValue(
//         error.response?.data || error.request || "Failed to remove to cart"
//       );
//     }
//   }
// );

// const initialState = {
//   cart: [],
//   ordersCart: [],
//   status: "idle",
//   error: null,
// };

// const cartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(addCart.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(addCart.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.cart = action.payload;
//       })
//       .addCase(addCart.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       })
//       .addCase(fetchAllOrdersCart.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(fetchAllOrdersCart.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.ordersCart = action.payload;
//       })
//       .addCase(fetchAllOrdersCart.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       })
//       .addCase(removeCart.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(removeCart.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.cart = action.payload;
//       })
//       .addCase(removeCart.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       })
//       .addMatcher(
//         (action) => action.type === removeCart.fulfilled.toString(),
//         (state, action) => {
//           state.status = "loading";
//         }
//       )
//       .addMatcher(
//         (action) => action.type === fetchAllOrdersCart.fulfilled.toString(),
//         (state, action) => {
//           state.status = "succeded";
//         }
//       );
//   },
// });

// export default cartSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../../apiEcommerce";
import { useDispatch } from "react-redux";

export const addCart = createAsyncThunk(
  "cart/addCart",
  async ({ eco_products_id, count, color_id }, { rejectWithValue, dispatch  }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/cart/updateOrCreate`,
        { eco_products_id, count, color_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      await dispatch(fetchAllOrdersCart()).unwrap();

      return response.data.data;
    } catch (error) {
      console.error("Error add to cart:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to add to cart"
      );
    }
  }
);

export const fetchAllOrdersCart = createAsyncThunk(
  "ordersCart/fetchAllOrdersCart",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.get(`/api/ecomerce/cart/getall`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid code.");
      }

      return response.data.data.orders;
    } catch (error) {
      console.error("Error fetching order:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch order"
      );
    }
  }
);

export const removeCart = createAsyncThunk(
  "cart/removeCart",
  async ({ cart_id }, { rejectWithValue, dispatch  }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/cart/remove`,
        { cart_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      await dispatch(fetchAllOrdersCart()).unwrap();

      return response.data.data;
    } catch (error) {
      console.error("Error remove to cart:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to remove to cart"
      );
    }
  }
);

export const updateCartCount = createAsyncThunk(
  "cart/updateCartCount",
  async ({ eco_products_id, cart_id, count, color_id}, { rejectWithValue , dispatch }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/cart/updateOrCreate`,
        { eco_products_id, cart_id, count },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      await dispatch(fetchAllOrdersCart()).unwrap();

      return response.data.data;
    } catch (error) {
      console.error("Error update cart count:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to update cart count"
      );
    }
  }
);

export const setExpressDelivery = createAsyncThunk(
  "cart/setExpressDelivery",
  async ({ order_id, status }, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/cart/express_delivary`,
        { order_id, status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error set express delivery:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to set express delivery"
      );
    }
  }
);

export const setCoupon = createAsyncThunk(
  "cart/setCoupon",
  async ({ order_id, coupon }, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/ecomerce/cart/set_coupon`,
        { order_id, coupon },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error set coupon:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to set coupon"
      );
    }
  }
);

const initialState = {
  cart: [],
  ordersCart: [],
  status: "idle",
  error: null,
  expressDelivery: false,
  expressStatus: "idle",
  expressError: null,
  coupon: null,
  couponStatus: "idle",
  couponError: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    clearCoupon: (state) => {
      state.coupon = null;
      state.couponStatus = "idle";
      state.couponError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCart.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cart = action.payload;
      })
      .addCase(addCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchAllOrdersCart.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllOrdersCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ordersCart = action.payload;
      })
      .addCase(fetchAllOrdersCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(removeCart.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(removeCart.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cart = action.payload;
      })
      .addCase(removeCart.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateCartCount.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCartCount.fulfilled, (state, action) => {
        state.status = "succeeded";
        const data = action.payload;
        if (data && state.ordersCart[0]) {
          if (data.cart) {
            const item = state.ordersCart[0].carts?.find(
              (ca) => ca.cart?.id === data.cart.id
            );
            if (item) {
              item.cart.count = data.cart.count;
              item.cart.unite_price = data.cart.unite_price;
            }
          }
          if (data.sub_total !== undefined)
            state.ordersCart[0].sub_total = data.sub_total;
          if (data.total_cost !== undefined)
            state.ordersCart[0].total_cost = data.total_cost;
          if (data.tax !== undefined) state.ordersCart[0].tax = data.tax;
          if (data.shipping !== undefined)
            state.ordersCart[0].shipping = data.shipping;
          if (data.discount !== undefined)
            state.ordersCart[0].discount = data.discount;
        }
      })
      .addCase(updateCartCount.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(setExpressDelivery.pending, (state) => {
        state.expressStatus = "loading";
        state.expressError = null;
      })
      .addCase(setExpressDelivery.fulfilled, (state, action) => {
        state.expressStatus = "succeeded";
        const data = action.payload;
        state.expressDelivery = data?.express_delivery === "yes" || data?.express_delivery === true;
        if (data && state.ordersCart[0]) {
          if (data.shipping !== undefined)
            state.ordersCart[0].shipping = data.shipping;
          if (data.total_cost !== undefined)
            state.ordersCart[0].total_cost = data.total_cost;
        }
      })
      .addCase(setExpressDelivery.rejected, (state, action) => {
        state.expressStatus = "failed";
        state.expressError = action.payload;
      })
      .addCase(setCoupon.pending, (state) => {
        state.couponStatus = "loading";
        state.couponError = null;
      })
      .addCase(setCoupon.fulfilled, (state, action) => {
        state.couponStatus = "succeeded";
        const data = action.payload;
        if (data?.coupon) state.coupon = data.coupon;
        if (data && state.ordersCart[0]) {
          if (data.discount !== undefined)
            state.ordersCart[0].discount = data.discount;
          if (data.total_cost !== undefined)
            state.ordersCart[0].total_cost = data.total_cost;
          if (data.sub_total !== undefined)
            state.ordersCart[0].sub_total = data.sub_total;
        }
      })
      .addCase(setCoupon.rejected, (state, action) => {
        state.couponStatus = "failed";
        state.couponError = action.payload;
      })
      .addMatcher(
        (action) => action.type === removeCart.fulfilled.toString(),
        (state) => {
          state.status = "loading";
        }
      )
      .addMatcher(
        (action) => action.type === fetchAllOrdersCart.fulfilled.toString(),
        (state) => {
          state.status = "succeded";
        }
      );
  },
});

export const { clearCoupon } = cartSlice.actions;
export default cartSlice.reducer;
